module.exports = __webpack_public_path__ + "static/img/BH.467ae590.jpg";